import { ToastContainer } from "react-toastify";
import "./App.css";
import Root from "./routes/Root";

function App() {
  return (
    <>
      <ToastContainer />
      <Root />
    </>
  );
}

export default App;
